// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step4YzCom[data-v-1d11d268] .el-tabs__item {\n  height: 46px;\n  line-height: 46px;\n}\n.step4YzCom[data-v-1d11d268] .el-select {\n  flex: 1;\n}\n.step4YzCom .tab-header[data-v-1d11d268] {\n  display: flex;\n  padding: 16px 75px 32px;\n  justify-content: center;\n}\n.step4YzCom .tab-bottom[data-v-1d11d268] {\n  padding: 0 40px;\n}\n.icon-company-box[data-v-1d11d268] {\n  width: 35px;\n  height: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
